export default {
  shortMessage: 2000,
  default: 6000,
  longMessage: 10000,
  veryLongMessage: 15000,
};
